import React from "react";
import { observer } from "mobx-react";
import { TenantDocumentCreateStore } from "../../store";
import { TenantDocumentCreateForm } from "./TenantDocumentCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { ChunkingStrategy } from "../../../../api/graphql";

export type TenantDocumentCreateProps = {
  tenantDocumentCreateStore: TenantDocumentCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TenantDocumentCreate: React.FC<TenantDocumentCreateProps> =
  observer(
    ({ tenantDocumentCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={tenantDocumentCreateStore.isSaving} />
          <TenantDocumentCreateForm
            tenantDocumentCreateStore={tenantDocumentCreateStore}
            nameError={tenantDocumentCreateStore.errors.name?.message}
            onNameChange={(value: string) => {
              tenantDocumentCreateStore.setNameValue(value);
            }}
            name={tenantDocumentCreateStore.entityValues.name}
            descriptionError={
              tenantDocumentCreateStore.errors.description?.message
            }
            onDescriptionChange={(value: string) => {
              tenantDocumentCreateStore.setDescriptionValue(value);
            }}
            description={tenantDocumentCreateStore.entityValues.description}
            fileOnRestoreFile={(id: string) =>
              tenantDocumentCreateStore.fileRestoreFile(id)
            }
            fileOnLoadFile={(file: any) =>
              tenantDocumentCreateStore.fileUploadFile(file)
            }
            fileOnCommitFile={(changes) =>
              tenantDocumentCreateStore.fileCommitFile(changes)
            }
            fileFiles={tenantDocumentCreateStore.entityValues.__file_files}
            fileError={tenantDocumentCreateStore.errors.file?.message}
            processingErrorError={
              tenantDocumentCreateStore.errors.processingError?.message
            }
            onProcessingErrorChange={(value: string) => {
              tenantDocumentCreateStore.setProcessingErrorValue(value);
            }}
            processingError={
              tenantDocumentCreateStore.entityValues.processingError
            }
            contentTypeError={
              tenantDocumentCreateStore.errors.contentType?.message
            }
            onContentTypeChange={(value: string) => {
              tenantDocumentCreateStore.setContentTypeValue(value);
            }}
            contentType={tenantDocumentCreateStore.entityValues.contentType}
            chunkingStrategyError={
              tenantDocumentCreateStore.errors.chunkingStrategy?.message
            }
            chunkingStrategyOptions={tenantDocumentCreateStore.getChunkingStrategyOptions()}
            onChunkingStrategyChange={(value: ChunkingStrategy) => {
              tenantDocumentCreateStore.setChunkingStrategyValue(value);
            }}
            chunkingStrategy={
              tenantDocumentCreateStore.entityValues.chunkingStrategy
            }
            chunkingSeparatorRegexError={
              tenantDocumentCreateStore.errors.chunkingSeparatorRegex?.message
            }
            onChunkingSeparatorRegexChange={(value: string) => {
              tenantDocumentCreateStore.setChunkingSeparatorRegexValue(value);
            }}
            chunkingSeparatorRegex={
              tenantDocumentCreateStore.entityValues.chunkingSeparatorRegex
            }
            chunkingMaxTokensError={
              tenantDocumentCreateStore.errors.chunkingMaxTokens?.message
            }
            onChunkingMaxTokensChange={(value: number | undefined) => {
              tenantDocumentCreateStore.setChunkingMaxTokensValue(value);
            }}
            chunkingMaxTokens={
              tenantDocumentCreateStore.entityValues.chunkingMaxTokens
            }
            chunkingOverlapTokensError={
              tenantDocumentCreateStore.errors.chunkingOverlapTokens?.message
            }
            onChunkingOverlapTokensChange={(value: number | undefined) => {
              tenantDocumentCreateStore.setChunkingOverlapTokensValue(value);
            }}
            chunkingOverlapTokens={
              tenantDocumentCreateStore.entityValues.chunkingOverlapTokens
            }
            dummyCRUDRestoredObservable={
              tenantDocumentCreateStore.dummyCRUDRestoredObservable
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={tenantDocumentCreateStore.isProcessing}
            onSave={() => tenantDocumentCreateStore.saveNewTenantDocument()}
            onCancel={() => tenantDocumentCreateStore.cancelNewTenantDocument()}
          />
          <ErrorDialog
            open={tenantDocumentCreateStore.errorDialogOpened}
            title={tenantDocumentCreateStore.errorTitle}
            description={tenantDocumentCreateStore.errorDescription}
            onClose={() => tenantDocumentCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
